import React, { useEffect,useState,useRef,createRef } from "react";
import { getCookie } from '../../services/DataRequestService.js';
import { Link, useLocation } from "react-router-dom";
import UserService from "../../services/UserService.js";
import mmxlogo from "../../Assets/Images/logo.webp"
import getNotification from "../../Redux/Action/action.js";
import { useDispatch } from "react-redux";
import AuthService from "../../services/AuthService.js";
const { REACT_APP_REDIRECT_URI } = process.env;
const { REACT_APP_UPLOAD_DATA } = process.env;

function Navbar2({scrollToSection}) {
  const usernameRef = useRef();
  const passwordRef = createRef();
  const agreementRef = useRef();

  const dispatch = useDispatch();
  const [logindata,setlogindata]=useState({})
const location=useLocation()
const [wrongidpass,setwrongidpass]=useState(false)
 
const submitLogin =async () => {
  try {    
    if (agreementRef.current.checked) {
      // AuthService.login({ username: usernameRef.current.value, password: passwordRef.current.value });
     let loggedin=await AuthService.login({ username: usernameRef.current.value, password: passwordRef.current.value });
   
  if(loggedin==="creds incorrect"){
    setwrongidpass(true)
    setTimeout(()=>{
      setwrongidpass(false)
    },5000)
  }
      // dispatch(getNotification({
      //   message:"Logged in Successfully",
      //   type:"success"
      // }))
  
    }
    else {
      dispatch(getNotification({
        message:"Please accept Agreement for Terms and Conditions",
        type:"warning"
      }))
     
    }

  } catch(error) {
    dispatch(getNotification({
      message:"We are facing some issues logging you in!!",
      type:"danger"
    }))

  }
}
  const onClose=()=>{

  }
  return (
    <>
      <div className="modal-overlay" onClick={onClose}></div>
 
   <div id="login" class="modal">
     
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body modal-body1">
              <div class="motit">
                <button type="button" class="close"><iconify-icon icon="material-symbols:close"></iconify-icon></button>
              </div>
              <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="loginwhitebg">
                  <div class="col-md-12 col-sm-12 col-xs-12">
                    <div class="loginiconbg">
                      <img src="/Assets/Images/loginicon1.webp"  class="max" alt="Revenue Radar" /><br />Login
                    </div>
                  </div>
                  <div class="col-md-12 col-sm-12 col-xs-12">
                    <div class="form-group1 my-2">
                    <input ref={usernameRef} type="text" class="form-control form-control1" id="username" placeholder="Enter Your username" />
                    </div>
                    <div class="form-group1">
                      <input ref={passwordRef} type="password" class="form-control form-control1" id="password" placeholder="Enter Your Password" />
                    </div>
                    <div class="forgotpwd">
                      <a href="#" aria-label="DE">Forgot Password?</a>
                    </div>
                 {wrongidpass &&    <div className="text-danger " style={{fontSize:"14px"}}> Please enter correct credentials!!</div>
                 }
                    <div class="form-group">
                      <div class="checkbox mx-1 my-auto">
                        <label><input ref={agreementRef} className="mx-1 my-auto" type="checkbox" id="agreement" />I agree to the Terms of Service and Privacy Policy.</label>
                      </div>
                    
                    </div>
                    <div class="form-group">
                      <div class="connectbtn">
                        <a onClick={submitLogin} href='#' aria-label="DE">Login <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon></a></div>


                    </div>
                    <div class="noaccount">
                      <a href="#" aria-label="DE">Don’t Have An Account?</a>
                    </div>
                    <div class="createaccount">
                      <a onClick={""} className='open-signup' aria-label="DE">Create Account Now</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
   
      { location.pathname !== "/dashboard"  &&  <nav className="navbar navbar-expand-sm sticky-top" style={{ zIndex: 4 }}>
        <a className="navbar-brand " href="/">
          <img src={mmxlogo} style={{ height: "50px" }} />
        </a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="text-success">
          <div style={{width: "30px",height: "3px", backgroundColor:"#0A4742",margin:"6px"}}></div>
          <div style={{width: "30px",height: "3px", backgroundColor:"#0A4742",margin:"6px"}}></div>
          <div style={{width: "30px",height: "3px", backgroundColor:"#0A4742",margin:"6px"}}></div>
          </span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
         

       
          <ul className="navbar-nav ml-auto">
            
          {/* {location.pathname!=="/dashboard" && <>  <li
              className={
                UserService.isLoggedIn() ? "nav-item active" : "d-none"
              }
            >
              <Link className="nav-link" onClick={()=>{scrollToSection("overview")}}>
                <button className="btn   drk noborder" style={{  }}>
                  Overview
                </button>
              </Link>
            </li>
            
          
         
            </>} 
          
          {location.pathname!=="/dashboard" &&   <li
              className={UserService.isLoggedIn()?"nav-item-active":"d-none"}         
            >
              <Link className="nav-link" to="/dashboard">
                <button className="btn  drk noborder" style={{  }}>
                  Dashboard
                </button>
              </Link>
            </li>}
           
            <li
              className={
                UserService.isLoggedIn() ? "nav-item active" : "d-none"
              }
            >
              <Link className="nav-link" to="/support">
                <button className="btn  drk noborder" style={{  }}>
                  <i className="fa fa-user" aria-hidden="true"></i> Support
                </button>
              </Link>
            </li> */}
            <li
              className="nav-item-active"                
            >
              <Link className="nav-link " onClick={()=>{scrollToSection("aboutus")}}>
                <button className="btn   noborder"  style={{color:"#015d52",fontWeight:"700"}}>
                  About Us
                </button>
              </Link>
            </li>
            <li
              className="nav-item-active"                
            >
              <Link className="nav-link " onClick={()=>{scrollToSection("features")}}>
                <button className="btn   noborder"  style={{color:"#015d52",fontWeight:"700"}}>
                  Features
                </button>
              </Link>
            </li>
            <li
              className="nav-item-active"                
            >
              <Link className="nav-link greentheme" onClick={()=>{scrollToSection("keybenefits")}}>
                <button className="btn  drk noborder greentheme" style={{color:"#015d52",fontWeight:"700"}}>
                  Benefits
                </button>
              </Link>
            </li>
            {/* <li
              className="nav-item-active"                
            >
              <Link className="nav-link" onClick={()=>{scrollToSection("contactus")}}>
                <button className="btn  drk noborder" style={{color:"#015d52",fontWeight:"700"}}>
                 Pricing
                </button>
              </Link>
            </li> */}
            <li
              className="nav-item-active"                
            >
              <Link className="nav-link" onClick={()=>{scrollToSection("contactus")}}>
                <button className="btn  drk noborder" style={{color:"#015d52",fontWeight:"700"}}>
                  Contact Us
                </button>
              </Link>
            </li>
            {/* <li class="loginmenu"><a  data-toggle="modal" data-target="#login" class="popup-btn" >Login <iconify-icon icon="ant-design:login-outlined"></iconify-icon></a></li> */}
             
            <li
              className={
                UserService.isLoggedIn() ? "d-none" : "  nav-item active"
              }
              
            >
              <Link
                className="nav-link"
           
                onClick={() => {
                  UserService.doLogin({
                    redirectUri:`${REACT_APP_REDIRECT_URI}/dashboard`,
                  })
                }}
   
              >
                <button className="btn noborder " style={{backgroundColor:"#015d52",color:"white",fontWeight:"700",borderRadius:"25px"}}>
                  Login  <i className="fas fa-sign-in-alt"></i>
                </button>
              </Link>
            </li> 
        {/* <li
              className={
                UserService.isLoggedIn() ? "d-none" : "  nav-item active"
              }
              
            >
              <Link
                className="nav-link"
                  data-toggle="modal" data-target="#login"
                // onClick={() => {
                //   UserService.doLogin({
                //     redirectUri:`${REACT_APP_REDIRECT_URI}/dashboard`,
                //   })
                // }}
   
              >
                <button className="btn noborder " style={{backgroundColor:"#015d52",color:"white",fontWeight:"700",borderRadius:"25px"}}>
                  Login <i className="fas fa-sign-in-alt"></i>
                </button>
              </Link>
            </li>  */}
            
            <li
              className={
                UserService.isLoggedIn() ? "d-none" : "nav-item active"
              }
            >
              <Link
                className="nav-link"
                onClick={() => UserService.doSignUp()}
              >
                <button className="btn noborder" style={{backgroundColor:"#2e835b",color:"white",fontWeight:"700",borderRadius:"25px"}}>
                   SignUp<i className="fas fa-user-plus mx-1"></i>
                </button>
              </Link>
            </li>

           
            <li >
            <Link
                className=""
            
              >
                <div className=" mx-3 d-flex" style={{  }}>
                <div className="mx-2  " style={{borderLeft:"1px solid #015d52",height:"40px"}}></div>
                  <div className="d-flex justify-content-between align-items-center">
                  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="2em" 
    height="3em" 
    viewBox="0 0 23 23" 
    style={{ marginRight: '10px' }}
  >
    <path 
      fill="#015d52" 
      d="M3.833 4h4.49L9.77 7.618l-2.325 1.55A1 1 0 0 0 7 10c.003.094 0 .001 0 .001v.021a2 2 0 0 0 .006.134q.008.124.035.33c.039.27.114.642.26 1.08c.294.88.87 2.019 1.992 3.141s2.261 1.698 3.14 1.992c.439.146.81.22 1.082.26a4 4 0 0 0 .463.04l.013.001h.008s.112-.006.001 0a1 1 0 0 0 .894-.553l.67-1.34l4.436.74v4.32c-2.111.305-7.813.606-12.293-3.874S3.527 6.11 3.833 4m5.24 6.486l1.807-1.204a2 2 0 0 0 .747-2.407L10.18 3.257A2 2 0 0 0 8.323 2H3.781c-.909 0-1.764.631-1.913 1.617c-.34 2.242-.801 8.864 4.425 14.09s11.848 4.764 14.09 4.425c.986-.15 1.617-1.004 1.617-1.913v-4.372a2 2 0 0 0-1.671-1.973l-4.436-.739a2 2 0 0 0-2.118 1.078l-.346.693a5 5 0 0 1-.363-.105c-.62-.206-1.481-.63-2.359-1.508s-1.302-1.739-1.508-2.36a5 5 0 0 1-.125-.447z"
    />
  </svg>
  <div className="greentheme" >
    <p style={{ margin: 0 }}>Call</p>
    <p style={{ margin: 0 }}>
      {/* <a href="tel:8049568423"> */}
      +91-80-49568423</p>
  </div>
</div>
                
                </div>
              </Link>
            </li>
            <li
              className={
                UserService.isLoggedIn() ? "nav-item active" : "d-none"
              }
            >
              
                <div className=" mx-3 d-flex" style={{  }}>
                {/* <div className="mx-2  " style={{borderLeft:"1px solid #015d52",height:"40px"}}></div> */}
                  <div className="d-flex justify-content-between align-items-center">
      
  
  <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="3em" 
    viewBox="0 0 23 23" 
    style={{ marginRight: '10px' }}
  >
    <path 
      fill="#015d52" 
  d="M15.71 12.71a6 6 0 1 0-7.42 0a10 10 0 0 0-6.22 8.18a1 1 0 0 0 2 .22a8 8 0 0 1 15.9 0a1 1 0 0 0 1 .89h.11a1 1 0 0 0 .88-1.1a10 10 0 0 0-6.25-8.19M12 12a4 4 0 1 1 4-4a4 4 0 0 1-4 4"></path></svg>
  <div className="greentheme">
    <p style={{ margin: 0 }}>Welcome to Revenue Radar</p>
    <p style={{ margin: 0,fontWeight:"500" }}  className="d-flex justify-content-between"> 
   <span>{UserService.getUsername()?.toUpperCase()}</span> 
    <span className="position-relative" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
      <i className="fas fa-angle-down" ></i>
    <div
              className={
                UserService.isLoggedIn() ? "position-absolute collapse card " : "d-none"
              }
              style={{top:"25px",right:"10px"}}
              id="collapseExample"
            >
              <Link
                className="nav-link"
            to="/dashboard"
              >
                <button className="btn  drk noborder" style={{color:"#015d52"}}>
                  Dashboard
                </button>
              </Link>
              <Link
                className="nav-link"
                onClick={() => {
                  UserService.doLogout({
                    redirectUri: `${REACT_APP_REDIRECT_URI}`,
                  });
                  // console.log(UserService.getToken());
                }}
              >
                <button className="btn  drk noborder" style={{color:"#015d52"}}>
                  Logout<i className="mx-1 fas fa-sign-in-alt"></i> 
                </button>
              </Link>
              {/* <Link
                className="nav-link"
                onClick={() => {
                  AuthService.logout({
                    redirectUri: `${REACT_APP_REDIRECT_URI}`,
                  });
                  // console.log(UserService.getToken());
                }}
              >
                <button className="btn  drk noborder" style={{color:"#015d52"}}>
                  Logout<i className="mx-1 fas fa-sign-in-alt"></i> 
                </button>
              </Link> */}
            </div> </span></p>
    
             </div>
 
</div>
                
                </div>
            
          
            </li>
          </ul>
      
        </div>

     
      </nav>}
    </>
  );
}

export default Navbar2;
